/**
 * UI state store
 * Manages upgrade prompts, toasts, and other UI state
 */

import { create } from 'zustand';

export type UpgradePromptType = 'rate_limit' | 'search' | 'consolidation' | 'saved-searches' | null;

interface UIStore {
  // Upgrade prompt state
  showUpgradePrompt: boolean;
  upgradePromptType: UpgradePromptType;

  // Actions
  showUpgrade: (type?: UpgradePromptType) => void;
  hideUpgrade: () => void;
}

export const useUIStore = create<UIStore>((set) => ({
  showUpgradePrompt: false,
  upgradePromptType: null,

  showUpgrade: (type = 'rate_limit') =>
    set({
      showUpgradePrompt: true,
      upgradePromptType: type,
    }),

  hideUpgrade: () =>
    set({
      showUpgradePrompt: false,
      upgradePromptType: null,
    }),
}));

// Convenience functions for direct use outside React components
export const ui = {
  showUpgrade: (type?: UpgradePromptType) => useUIStore.getState().showUpgrade(type),
  hideUpgrade: () => useUIStore.getState().hideUpgrade(),
};
